export default __webpack_public_path__ + "assets/images/80f48155e47d3c9bb0e6e8d9470ccf2a.png";